import getClosestVueParent from '../../core/utils/getClosestVueParent';

export default {
  props: {
    modelValue: [String, Number],
    modelModifiers: {},
    debounce: {
      type: Number,
      default: 1e2,
    },
    disabled: Boolean,
    required: Boolean,
    maxlength: [Number, String],
    name: String,
    placeholder: String,
    readonly: Boolean,
    scrollParams: {
      type: Object,
      default: () => {
        return {
          enable: false,
          config: {},
        };
      },
    },
  },
  data() {
    return {
      timeout: 0,
      inputValue: '',
    };
  },
  watch: {
    modelValue() {
      this.inputValue = this.modelValue;
      this.setParentValue();
    },
    disabled() {
      this.setParentDisabled();
    },
    required() {
      this.setParentRequired();
    },
    placeholder() {
      this.setParentPlaceholder();
    },
    maxlength() {
      this.handleMaxLength();
    },
  },
  methods: {
    handleMaxLength() {
      this.parentContainer.enableCounter = this.maxlength > 0;
      this.parentContainer.counterLength = this.maxlength;
    },
    setParentValue(value) {
      if (this.parentContainer) {
        const val = value || this.inputValue;
        this.parentContainer.setValue(val);
        this.parentContainer.inputLength = val ? val.length : 0;
      }
    },
    setParentDisabled() {
      if (this.parentContainer) {
        this.parentContainer.isDisabled = this.disabled;
      }
    },
    setParentRequired() {
      this.parentContainer.isRequired = this.required;
    },
    setParentPlaceholder() {
      this.parentContainer.hasPlaceholder = !!this.placeholder;
    },
    onFocus(event) {
      if (this.parentContainer) {
        this.parentContainer.isFocused = true;
      }
    },
    scrollIfNeeded($event) {
      const { target } = $event;
      if (!Element.prototype.scrollIntoView) {
        setTimeout(function () {
          target.focus();
          this.$emit('focus', this.inputValue, $event);
        }, 200);
      } else {
        target.scrollIntoView(this.scrollParams.config);
      }
    },
    onBlur(event) {
      this.parentContainer.isFocused = false;
    },
    onChange(event) {
      if (this.modelModifiers?.lazy) {
        this.$emit('update:modelValue', this.inputValue);
      }
    },
    onUpdateValue(value) {
      if (this.debounce && this.debounce > 0) {
        if (this.timeout) {
          window.clearTimeout(this.timeout);
        }
        this.timeout = window.setTimeout(() => {
          this.$emit('update:modelValue', value);
        }, this.debounce);
      } else if (!this.modelModifiers?.lazy) {
        this.$emit('update:modelValue', value);
      }

      this.setParentValue(value);
    },
  },
  mounted() {
    this.inputValue = this.modelValue;
    this.$el.value = this.modelValue;
    this.parentContainer = getClosestVueParent(this.$parent, 'md-input-container');

    if (!this.parentContainer) {
      throw new Error('You should wrap it in a md-input-container');
    }

    this.parentContainer.inputInstance = this;
    this.setParentDisabled();
    this.setParentRequired();
    this.setParentPlaceholder();
    this.handleMaxLength();
    this.setParentValue();
  },
};
